export * from './blockIconsCommunicationMailNew';
export * from './blockIconsCommunicationCallNew';
export * from './blockIconsCommunicationNotificationsNew';
export * from './blockIconsCommunicationSendNew';
export * from './blockIconsCommunicationChatNew';
export * from './blockIconsCommunicationLinkNew';
export * from './blockIconsCommunicationForumNew';
export * from './blockIconsCommunicationInventory2New';
export * from './blockIconsCommunicationPhoneInTalkNew';
export * from './blockIconsCommunicationChatBubbleNew';
export * from './blockIconsCommunicationContactSupportNew';
export * from './blockIconsCommunicationNotificationsActiveNew';
export * from './blockIconsCommunicationAlternateEmailNew';
export * from './blockIconsCommunicationSmsNew';
export * from './blockIconsCommunicationCommentNew';
export * from './blockIconsCommunicationPowerSettingsNewNew';
export * from './blockIconsCommunicationHubNew';
export * from './blockIconsCommunicationPersonSearchNew';
export * from './blockIconsCommunicationImportContactsNew';
export * from './blockIconsCommunicationContactsNew';
export * from './blockIconsCommunicationContactMailNew';
export * from './blockIconsCommunicationLiveHelpNew';
export * from './blockIconsCommunicationForwardToInboxNew';
export * from './blockIconsCommunicationReviewsNew';
export * from './blockIconsCommunicationMarkEmailUnreadNew';
export * from './blockIconsCommunicationLanNew';
export * from './blockIconsCommunicationHourglassTopNew';
export * from './blockIconsCommunicationContactPhoneNew';
export * from './blockIconsCommunicationModeCommentNew';
export * from './blockIconsCommunicationInboxNew';
export * from './blockIconsCommunicationDraftsNew';
export * from './blockIconsCommunicationOutgoingMailNew';
export * from './blockIconsCommunicationHourglassBottomNew';
export * from './blockIconsCommunicationMarkEmailReadNew';
export * from './blockIconsCommunicationLinkOffNew';
export * from './blockIconsCommunicationCalendarAddOnNew';
export * from './blockIconsCommunicationAddCommentNew';
export * from './blockIconsCommunicationPhoneEnabledNew';
export * from './blockIconsCommunicationGTranslateNew';
export * from './blockIconsCommunicationSpeakerNotesNew';
export * from './blockIconsCommunicationPermPhoneMsgNew';
export * from './blockIconsCommunicationCoPresentNew';
